module.exports = __webpack_public_path__ + "img/monitor-03.ae18b44b.svg";